module.exports = __webpack_public_path__ + "static/media/iconDelete2.33f30706.svg";